import {
  NgModule,
  LOCALE_ID,
  isDevMode,
} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {PLATFORM_ID, APP_ID, Inject} from '@angular/core';
import {isPlatformBrowser, ViewportScroller} from '@angular/common';
import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {ApiModule} from './api/api.module';
import {registerLocaleData} from '@angular/common';
import localePL from '@angular/common/locales/pl';
import extraLocalePL from '@angular/common/locales/extra/pl';
import localeUS from '@angular/common/locales/en';
import extraLocaleUS from '@angular/common/locales/extra/en';
import localeDE from '@angular/common/locales/de';
import extraLocaleDE from '@angular/common/locales/extra/de';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {Event, Router, Scroll, RouterModule} from '@angular/router';
import {filter} from 'rxjs/operators';
import {provideClientHydration} from '@angular/platform-browser';
import {ProjectAliasRedirectComponent} from './core/pages/project-alias-redirect.component';
// import {NgxBackForwardCacheModule} from 'ngx-back-forward-cache';
// import {NgxScrollPositionRestorationModule} from 'ngx-scroll-position-restoration';
// import { BottomSheetModule } from 'swipe-bottom-sheet/angular';

registerLocaleData(localePL, 'pl-PL', extraLocalePL);
registerLocaleData(localeUS, 'en-US', extraLocaleUS);
registerLocaleData(localeDE, 'de-DE', extraLocaleDE);

const HYDRATION_PROVIDERS = typeof document !== 'undefined'
  && !!document.querySelector('app-root')?.hasAttribute('ngh')
  ? [provideClientHydration()]
  : [];

// The local dev server does not emit ngsw-worker.js, but the media wrapper is
// self-sufficient there and lets localhost exercise the same Cache Storage
// read-through path as production. SSR never evaluates a browser location.
const MEDIA_OFFLINE_WORKER_ENABLED = environment.production
  || (typeof location !== 'undefined' && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname));

@NgModule({
  declarations: [
    AppComponent,
    ProjectAliasRedirectComponent
  ],
  imports: [
    // BottomSheetModule,
    SharedModule,
    CoreModule,
    ApiModule,
    RouterModule,
    AppRoutingModule,
    ServiceWorkerModule.register('media-offline-ngsw-worker.js', {
      enabled: MEDIA_OFFLINE_WORKER_ENABLED,
      scope: './',
      registrationStrategy: 'registerImmediately'
    }),
    // NgxBackForwardCacheModule.forRoot({disableNgxBackForwardCache: true}),
    // NgxScrollPositionRestorationModule.forRoot({debug: true})
  ],
  providers: [
    ...HYDRATION_PROVIDERS,
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    @Inject(APP_ID) appId: string,
    router: Router,
    viewportScroller: ViewportScroller
  ) {
    router.events.pipe(
      filter((e: Event): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {
      if (e.position) {
        // backward navigation
        viewportScroller.scrollToPosition(e.position);
      } else if (e.anchor) {
        // anchor navigation
        viewportScroller.scrollToAnchor(e.anchor);
      } else {
        // forward navigation
        viewportScroller.scrollToPosition([0, 0]);
      }
    });

    const platform = isPlatformBrowser(platformId) ? 'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
